// ----------------------------------------------------------------------
// <copyright file="Izenda.SystemModeSetting.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function () {
  var m = require('mobx');
  var extendObservable = require('mobx').extendObservable;  
  var settingConstant = require('logic/data/Izenda.SettingConstants');

  function SystemModeSetting() {    
    var props = {
      systemMode: settingConstant.TENANT_MODE,
      allowDuplicateUser: true,
      isSingleMode: function () {
        return this.systemMode === settingConstant.SYSTEM_MODE;
      }
    }

    extendObservable(this, props);
  };

  /**
   * Read system mode setting drom API
   * @param  {object} data [receive from API]
   */
  SystemModeSetting.prototype.readSystemModeSetting = m.action(function (data) {
    this.systemMode = data.systemMode;
    this.allowDuplicateUser = data.allowDuplicateUser;
  });

  /**
   * Switch to single mode
   * @param {int} mode
   */
  SystemModeSetting.prototype.switchToSingle = m.action(function () {
    this.systemMode = settingConstant.SYSTEM_MODE;
    this.allowDuplicateUser = false;
  });

  /**
   * Switch to multi mode
   * @param {int} mode
   */
  SystemModeSetting.prototype.switchToMulti = m.action(function () {
    this.systemMode = settingConstant.TENANT_MODE;
    this.allowDuplicateUser = true;
  });

  /**
   * Allow duplicate user
   * @param {int} allowDuplicate
   */
  SystemModeSetting.prototype.updateAllowDuplicateUser = function (allowDuplicate) {
    this.allowDuplicateUser = allowDuplicate;
  };

  module.exports = SystemModeSetting;
}())



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.SystemModeSetting.js